import { TZ } from './constants.ts'

/** The four sky looks of the island art (PRD §3.1). */
export type SkyPhase = 'subuh' | 'siang' | 'maghrib' | 'isya'

export type SkyInfo = {
  phase: SkyPhase
  /** Human label shown in the pill, e.g. "Waktu Subuh". */
  label: string
  icon: 'sunrise' | 'sun' | 'sunset' | 'moon-star'
}

const hm = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })

/** Minutes since midnight in WIB, whatever the device timezone is. */
export function wibMinutes(d: Date = new Date()): number {
  const [h, m] = hm.format(d).split(':').map(Number) as [number, number]
  return h * 60 + m
}

/** Sky for a moment in time. Boundaries: 03:30 / 06:00 / 11:00 / 15:30 / 17:45 / 18:45. */
export function skyAt(d: Date = new Date()): SkyInfo {
  const m = wibMinutes(d)
  if (m >= 210 && m < 360) return { phase: 'subuh', label: 'Waktu Subuh', icon: 'sunrise' }
  if (m >= 360 && m < 660) return { phase: 'siang', label: 'Pagi hari', icon: 'sun' }
  if (m >= 660 && m < 930) return { phase: 'siang', label: 'Siang hari', icon: 'sun' }
  if (m >= 930 && m < 1065) return { phase: 'maghrib', label: 'Sore hari', icon: 'sunset' }
  if (m >= 1065 && m < 1125) return { phase: 'maghrib', label: 'Waktu Maghrib', icon: 'sunset' }
  return { phase: 'isya', label: 'Waktu Isya', icon: 'moon-star' }
}

/** Fixed art for a given phase (used by the dev override and tests). */
export const skyForPhase = (phase: SkyPhase): SkyInfo => ({
  subuh: { phase, label: 'Waktu Subuh', icon: 'sunrise' as const },
  siang: { phase, label: 'Siang hari', icon: 'sun' as const },
  maghrib: { phase, label: 'Waktu Maghrib', icon: 'sunset' as const },
  isya: { phase, label: 'Waktu Isya', icon: 'moon-star' as const },
})[phase]
